class LocationService {
    constructor() {
        this.watchId = null;
        this.currentPosition = null;
        this.callbacks = [];
    }

    async getCurrentPosition() {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(new Error('Geolocation is not supported by this browser'));
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.currentPosition = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        accuracy: position.coords.accuracy,
                        timestamp: Date.now()
                    };
                    resolve(this.currentPosition);
                },
                (error) => {
                    reject(error);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 0
                }
            );
        });
    }

    startWatching(callback) {
        if (!navigator.geolocation) {
            throw new Error('Geolocation is not supported by this browser');
        }

        this.callbacks.push(callback);

        if (!this.watchId) {
            this.watchId = navigator.geolocation.watchPosition(
                (position) => {
                    this.currentPosition = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        accuracy: position.coords.accuracy,
                        timestamp: Date.now()
                    };

                    this.callbacks.forEach(cb => cb(this.currentPosition));
                },
                (error) => {
                    console.error('Geolocation error:', error);
                    this.callbacks.forEach(cb => cb(null, error));
                },
                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 0
                }
            );
        }

        return this.watchId;
    }

    stopWatching(callback) {
        if (callback) {
            this.callbacks = this.callbacks.filter(cb => cb !== callback);
        }

        if (this.callbacks.length === 0 && this.watchId) {
            navigator.geolocation.clearWatch(this.watchId);
            this.watchId = null;
        }
    }

    calculateDistance(lat1, lng1, lat2, lng2) {
        const R = 6371e3;
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lng2 - lng1) * Math.PI / 180;

        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                  Math.cos(φ1) * Math.cos(φ2) *
                  Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }

    calculateRouteDistance(route) {
        if (route.length < 2) return 0;

        let totalDistance = 0;
        for (let i = 0; i < route.length - 1; i++) {
            const current = route[i];
            const next = route[i + 1];
            totalDistance += this.calculateDistance(
                current.lat, current.lng,
                next.lat, next.lng
            );
        }

        return totalDistance;
    }
}

export default new LocationService();